export default {
  sections: {
    setup_fee: {
      title: 'Costi di configurazione',
      description: 'Costi di configurazione da {{amount}} – invece di 1.000+',
    },
  },
  labels: {
    month: 'Mese (NETTO)',
    one_time_fee: 'Tariffa una tantum',
    more_options: 'Altre opzioni',
    discount_badge: '-{{percentage}}%',
  },
  features: {
    app: 'La tua app su App Store & Google Play',
    push_notifications: 'Notifiche push per le offerte',
    loyalty: 'Fidelizzazione clienti tramite programmi fedeltà',
    offline_orders: 'Ordini offline possibili',
    individual_design: 'Design app personalizzato',
  },
  setup_fee_options: {
    150: 'Configurazione standard',
    75: 'Ridotto',
    0: 'Nessun costo di creazione',
  },
  feedback: {
    contract_signed_already: {
      title: 'Il contratto è già stato firmato',
      description: 'Contatta il supporto tecnico se hai bisogno di apportare modifiche',
    },
  },
};
